// GENERATED by scripts/build-illustrations.mjs — do not edit
import Glyph404 from '@/assets/illustrations/source/error/404.svg?react';
import GlyphAudioUnavailable from '@/assets/illustrations/source/error/audio-unavailable.svg?react';
import GlyphConsentRejected from '@/assets/illustrations/source/error/consent-rejected.svg?react';
import GlyphError500 from '@/assets/illustrations/source/error/error-500.svg?react';
import GlyphSaFailedToJoin from '@/assets/illustrations/source/error/sa-failed-to-join.svg?react';
import GlyphSaUnableToRemove from '@/assets/illustrations/source/error/sa-unable-to-remove.svg?react';
import GlyphSaUnavailable from '@/assets/illustrations/source/error/sa-unavailable.svg?react';
import GlyphAllSet from '@/assets/illustrations/source/success/all-set.svg?react';
import GlyphConsentApproved from '@/assets/illustrations/source/success/consent-approved.svg?react';
import GlyphConsentRequest from '@/assets/illustrations/source/success/consent-request.svg?react';
import GlyphNoPendingActions from '@/assets/illustrations/source/success/no-pending-actions.svg?react';
import GlyphSaAdd from '@/assets/illustrations/source/success/sa-add.svg?react';
import GlyphSaLoading from '@/assets/illustrations/source/success/sa-loading.svg?react';
import GlyphSaWaitingApproval from '@/assets/illustrations/source/success/sa-waiting-approval.svg?react';
import GlyphServiceUnavailable from '@/assets/illustrations/source/unknown/service-unavailable.svg?react';
import GlyphLogIn from '@/assets/illustrations/source/warning/log-in.svg?react';
import GlyphMeetingLink from '@/assets/illustrations/source/warning/meeting-link.svg?react';
import GlyphWarning from '@/assets/illustrations/source/warning/warning.svg?react';
import {
  IllustrationBase,
  type IllustrationProps,
} from '@/components/Illustration/IllustrationBase';

export const Illustration404 = (props: IllustrationProps) => (
  <IllustrationBase glyph={Glyph404} name="404" variant="error" {...props} />
);

export const IllustrationAudioUnavailable = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphAudioUnavailable}
    name="audio-unavailable"
    variant="error"
    {...props}
  />
);

export const IllustrationConsentRejected = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphConsentRejected}
    name="consent-rejected"
    variant="error"
    {...props}
  />
);

export const IllustrationError500 = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphError500}
    name="error-500"
    variant="error"
    {...props}
  />
);

export const IllustrationSaFailedToJoin = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaFailedToJoin}
    name="sa-failed-to-join"
    variant="error"
    {...props}
  />
);

export const IllustrationSaUnableToRemove = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaUnableToRemove}
    name="sa-unable-to-remove"
    variant="error"
    {...props}
  />
);

export const IllustrationSaUnavailable = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaUnavailable}
    name="sa-unavailable"
    variant="error"
    {...props}
  />
);

export const IllustrationAllSet = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphAllSet}
    name="all-set"
    variant="success"
    {...props}
  />
);

export const IllustrationConsentApproved = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphConsentApproved}
    name="consent-approved"
    variant="success"
    {...props}
  />
);

export const IllustrationConsentRequest = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphConsentRequest}
    name="consent-request"
    variant="success"
    {...props}
  />
);

export const IllustrationNoPendingActions = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphNoPendingActions}
    name="no-pending-actions"
    variant="success"
    {...props}
  />
);

export const IllustrationSaAdd = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaAdd}
    name="sa-add"
    variant="success"
    {...props}
  />
);

export const IllustrationSaLoading = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaLoading}
    name="sa-loading"
    variant="success"
    {...props}
  />
);

export const IllustrationSaWaitingApproval = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphSaWaitingApproval}
    name="sa-waiting-approval"
    variant="success"
    {...props}
  />
);

export const IllustrationServiceUnavailable = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphServiceUnavailable}
    name="service-unavailable"
    variant="unknown"
    {...props}
  />
);

export const IllustrationLogIn = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphLogIn}
    name="log-in"
    variant="warning"
    {...props}
  />
);

export const IllustrationMeetingLink = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphMeetingLink}
    name="meeting-link"
    variant="warning"
    {...props}
  />
);

export const IllustrationWarning = (props: IllustrationProps) => (
  <IllustrationBase
    glyph={GlyphWarning}
    name="warning"
    variant="warning"
    {...props}
  />
);
